var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6713 14.9814C15.4733 14.9771 15.2841 14.8986 15.1412 14.7614L12.2013 11.7614L9.26135 14.7614C9.11917 14.8939 8.93111 14.966 8.73681 14.9626C8.54251 14.9592 8.35713 14.8805 8.21972 14.743C8.08231 14.6056 8.00355 14.4203 8.00012 14.226C7.99669 14.0317 8.06881 13.8436 8.20129 13.7014L11.6713 10.2114C11.8143 10.0757 12.0041 10 12.2013 10C12.3985 10 12.5882 10.0757 12.7313 10.2114L16.2013 13.7014C16.3417 13.842 16.4206 14.0326 16.4206 14.2314C16.4206 14.4301 16.3417 14.6208 16.2013 14.7614C16.0584 14.8986 15.8693 14.9771 15.6713 14.9814Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottom);
export default __webpack_public_path__ + "static/media/arrowBottom.a53d9f07a6cee6f02540f50af7235120.svg";
export { ForwardRef as ReactComponent };